import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../redux/actions/authActions";
import "./styles.css";
export default function LoginModal({ onClose }) {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await dispatch(login(email, password));
      // Succès : on ferme la modal
      onClose();
    } catch (err) {
      // Afficher l'erreur
      setError(err.message || "Erreur lors de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginModalOverlay" >
      <div className="loginModal">
        <button className="loginModalClose" onClick={onClose} >
          ×
        </button>
        <h2>Connexion</h2>
        <form onSubmit={handleSubmit}>
          <div className="loginModal-input-form">
            <label>Email</label>
            <input
              type="email"
              value={email}
              placeholder="Entrez votre email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="loginModal-input-form">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              placeholder="votre mot de passe"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div className="loginModalError">
              {error}
            </div>
          )}
            <div className="loginModal-input-form">
                <button type="submit" disabled={loading}>
                    {loading ? "Connexion..." : "Se connecter"}
                </button>
            </div>
          
        </form>
      </div>
    </div>
  );



};
